// images
import blogImg1 from "../images/blog/1.png";
import blogImg2 from "../images/blog/2.png";
import blogImg3 from "../images/blog/3.png";

import blogSingleImg1 from "../images/blog/1.png";
import blogSingleImg2 from "../images/blog/2.png";
import blogSingleImg3 from "../images/blog/3.png";



const blogs = [
    {
        id: 'termes-d-utilisation',
        contenu:   <div className="container my-5">
        <h1 className="text-center mb-4">Termes et Conditions d'Utilisation</h1>
    
        <p>Bienvenue sur notre site web. En utilisant notre site, vous acceptez de respecter les termes et conditions énoncés ci-dessous. Veuillez lire attentivement ces termes avant d'utiliser notre site.</p>
    
        <h2>1. Introduction</h2>
        <p>Ces Termes et Conditions régissent l'utilisation de notre site web, de ses services et de ses fonctionnalités. Si vous ne souhaitez pas accepter ces termes, veuillez ne pas utiliser ce site.</p>
    
        <h2>2. Utilisation du Site</h2>
        <p>Vous vous engagez à utiliser ce site conformément aux lois et réglementations en vigueur. Vous ne devez pas utiliser ce site à des fins illégales ou pour nuire à d'autres utilisateurs.</p>
    
        <h2>3. Propriété Intellectuelle</h2>
        <p>Le contenu, les graphiques, les logos, les images et tous les autres éléments du site sont la propriété de Get Riad et sont protégés par des droits d'auteur et d'autres lois de propriété intellectuelle. Vous ne pouvez pas reproduire ou distribuer ce contenu sans autorisation explicite.</p>
    
        <h2>4. Collecte et Utilisation des Données Personnelles</h2>
        <p>Nous collectons des informations personnelles lorsque vous utilisez notre site. Ces informations sont utilisées uniquement dans le but d'améliorer votre expérience utilisateur et de répondre à vos demandes. Nous respectons votre vie privée et nous engageons à ne pas partager vos informations personnelles avec des tiers sans votre consentement.</p>
    
        <h2>5. Cookies</h2>
        <p>Nous utilisons des cookies pour améliorer votre expérience de navigation. En continuant à utiliser notre site, vous acceptez l'utilisation de cookies conformément à notre politique de cookies.</p>
    
        <h2>6. Responsabilité</h2>
        <p>Nous nous efforçons de maintenir notre site web accessible en tout temps, mais nous ne pouvons garantir que le site sera exempt d'erreurs, de bugs ou de problèmes techniques. Vous utilisez ce site à vos propres risques.</p>
    
        <h2>7. Modifications des Termes</h2>
        <p>Nous nous réservons le droit de modifier ces termes et conditions à tout moment. Toute modification sera publiée sur cette page. Il est de votre responsabilité de consulter régulièrement ces termes afin de rester informé de toute modification.</p>
    
        <h2>8. Contact</h2>
        <p>Si vous avez des questions concernant ces termes et conditions, vous pouvez nous contacter à l'adresse suivante : <a href="mailto:contact@getriad.com">contact@getriad.com</a>.</p>
    
         
      </div>
    },
    {
        id:"politique-de-confidentialite",
        contenu:<div className="container my-5">
        <h1 className="text-center mb-4">Politique de Confidentialité</h1>
    
        <p>Nous respectons votre vie privée et nous nous engageons à protéger les informations personnelles que vous partagez avec nous. Cette politique de confidentialité décrit comment nous collectons, utilisons et protégeons vos données.</p>
    
        <h2>1. Informations Collectées</h2>
        <p>Nous collectons les informations personnelles suivantes lorsque vous utilisez notre site :</p>
        <ul>
           
          <li>Adresse IP</li>
          <li>Données de navigation et cookies</li>
        </ul>
        <br/>
        <h2>2. Utilisation des Informations</h2>
        <p>Les informations collectées sont utilisées dans les buts suivants :</p>
        <ul>
          <li>Améliorer l'expérience utilisateur sur notre site</li>
          <li>Personnaliser le contenu et les publicités</li>
          <li>Envoyer des notifications, des mises à jour ou des informations marketing (avec votre consentement)</li>
          <li>Analyser l’utilisation du site pour des fins statistiques</li>
        </ul>
        <br/>
        <h2>3. Cookies</h2>
        <p>Nous utilisons des cookies pour améliorer votre expérience sur notre site. Les cookies nous aident à comprendre comment vous interagissez avec le site et à personnaliser les publicités que nous vous montrons. Vous pouvez accepter ou refuser l'utilisation de cookies, mais certaines fonctionnalités du site peuvent ne pas fonctionner correctement sans eux.</p>
    <br/>
        <h2>4. Partage des Informations</h2>
        <p>Nous ne vendons, n’échangeons et ne partageons pas vos informations personnelles avec des tiers, sauf dans les cas suivants :</p>
        <ul>
          <li>Avec des prestataires de services qui nous aident à gérer notre site et à traiter les transactions (par exemple, les services de paiement)</li>
          <li>Lorsque la loi l'exige ou pour protéger nos droits légaux</li>
        </ul>
        <br/>
        <h2>5. Sécurité des Données</h2>
        <p>Nous mettons en place des mesures de sécurité pour protéger vos données contre les accès non autorisés, les modifications ou les destructions. Toutefois, aucune méthode de transmission sur Internet n'est totalement sûre, et nous ne pouvons garantir à 100% la sécurité des informations transmises.</p>
        <br/>
        <h2>6. Vos Droits</h2>
        <p>Vous avez le droit de :</p>
        <ul>
          <li>Accéder à vos données personnelles</li>
          <li>Demander la correction ou la suppression de vos données</li>
          <li>Retirer votre consentement à l'utilisation de vos données</li>
        </ul>
        <p>Pour exercer ces droits, vous pouvez nous contacter à l'adresse suivante : <a href="mailto:contact@getriad.com">contact@getriad.com</a>.</p>
        <br/>
        <h2>7. Modifications de la Politique de Confidentialité</h2>
        <p>Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment. Les modifications seront publiées sur cette page. Veuillez consulter cette page régulièrement pour vous tenir informé des changements.</p>
        <br/>
        <h2>8. Contact</h2>
        <p>Si vous avez des questions concernant cette politique de confidentialité ou la manière dont nous traitons vos informations personnelles, veuillez nous contacter à l'adresse suivante : <a href="mailto:contact@getriad.com">contact@getriad.com</a>.</p>
    
        
      </div>
    }
];
export default blogs;